(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aes-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('aes-hero-slider')) return;

    class AesHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.aes-slide'));
        this.tabs = Array.from(this.querySelectorAll('.aes-tab'));
        if (!this.slides.length) return;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.auto = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce;
        this.classList.toggle('no-auto', !this.auto);
        this.index = 0;
        this.userPaused = false;
        this.holding = false;

        this.tabs.forEach((tab, n) => {
          tab.addEventListener('click', () => this.go(n));
          const bar = tab.querySelector('.aes-tab__bar span');
          if (bar) bar.addEventListener('animationend', () => {
            if (this.auto && n === this.index) this.go(this.index + 1);
          });
        });

        const prev = this.querySelector('[data-aes-prev]');
        const next = this.querySelector('[data-aes-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
        if (next) next.addEventListener('click', () => this.go(this.index + 1));

        this.pauseBtn = this.querySelector('[data-aes-pause]');
        if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
          this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Riprendi lo scorrimento' : 'Metti in pausa lo scorrimento');
          this.sync();
        });

        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hold(true); });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.hold(false); });
        this.addEventListener('focusin', () => this.hold(true));
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.hold(false); });

        const nav = this.querySelector('.aes-tabs');
        if (nav) nav.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));
          this.tabs[this.index].focus();
        });

        // Swipe su telefono e tablet
        const stage = this.querySelector('.aes-hero__stage');
        let startX = null, startY = null;
        stage.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse') return;
          startX = e.clientX; startY = e.clientY;
        });
        stage.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX, dy = e.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        });

        // Mappa: nome della regione al passaggio
        this.querySelectorAll('.aes-map').forEach((map) => {
          const tip = map.querySelector('.aes-tip');
          if (!tip) return;
          const nameEl = tip.querySelector('strong');
          const show = (e) => {
            const region = e.target.closest && e.target.closest('.aes-r');
            if (!region) { tip.hidden = true; return; }
            nameEl.textContent = region.dataset.name;
            const r = map.getBoundingClientRect();
            tip.style.transform = 'translate(' + (e.clientX - r.left) + 'px,' + (e.clientY - r.top) + 'px)';
            tip.hidden = false;
          };
          map.addEventListener('pointermove', show);
          map.addEventListener('pointerdown', show);
          map.addEventListener('pointerleave', () => { tip.hidden = true; });
        });

        // Editor del tema: selezionando una slide la mostra e ferma lo scorrimento
        this.onSelect = (e) => {
          if (!this.contains(e.target)) return;
          const n = this.slides.indexOf(e.target.closest('.aes-slide'));
          if (n > -1) { this.go(n); this.hold(true); }
        };
        this.onDeselect = (e) => { if (this.contains(e.target)) this.hold(false); };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);

        this.go(0, true);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      hold(value) { this.holding = value; this.sync(); }
      sync() { this.classList.toggle('is-paused', this.userPaused || this.holding); }

      go(n, first) {
        const len = this.slides.length;
        n = ((n % len) + len) % len;
        if (n === this.index && !first) return;
        this.slides.forEach((slide, k) => {
          const on = k === n;
          slide.classList.toggle('is-active', on);
          slide.toggleAttribute('inert', !on);
          if (on) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
        });
        this.tabs.forEach((tab, k) => {
          tab.classList.remove('is-current');
          tab.setAttribute('aria-current', k === n ? 'true' : 'false');
        });
        const tab = this.tabs[n];
        if (tab) { void tab.offsetWidth; tab.classList.add('is-current'); }
        this.dataset.scheme = this.slides[n].dataset.scheme || 'dark';
        this.index = n;
      }
    }

    customElements.define('aes-hero-slider', AesHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
